<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Ajouter un client</md-dialog-title>
    <form action="http://binet-expertise.fr/facturation/server/insertClient.php" method="post"> 
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Nom</label>
            <md-input type="text" name="nom"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100">        
          <md-field>
            <label>Adresse</label>
            <md-input type="text" name="adresse"></md-input>
          </md-field>
        </div>
        
        <div class="md-layout-item">        
          <md-field>
            <label>Ville</label>
            <md-input type="text" name="ville"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item">        
          <md-field>
              <label>Code postal</label>
              <md-input type="text" name="codePostal"></md-input>
            </md-field>
        </div>                
        
        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Remise commerciale</label>
            <md-input type="text" name="remiseCommerciale"></md-input>
          </md-field>
        </div>
      </div>
      <md-dialog-actions>
           <md-button type="submit" class="md-primary submit-button" @click="showDialog = false">Ajouter</md-button>
      </md-dialog-actions>
    </form>      
    </md-dialog>
    

    <md-button class="md-raised" @click="showDialog = true">Ajouter un client</md-button>
    <md-table md-card>
      <md-table-toolbar>
        <h1 class="md-title">Liste des clients</h1>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head md-numeric>ID</md-table-head>
        <md-table-head>Nom</md-table-head>
        <md-table-head>Adresse</md-table-head>
        <md-table-head>Code postal</md-table-head>
        <md-table-head>Ville</md-table-head>
        <md-table-head>Remise commerciale</md-table-head>      
      </md-table-row>

      <md-table-row v-for="(client, index) in clients" v-bind:key="index">
        <md-table-cell md-numeric>{{ index }}</md-table-cell>
        <md-table-cell>{{client.nom}}</md-table-cell>
        <md-table-cell>{{client.adresse}}</md-table-cell>
        <md-table-cell>{{client.codePostal}}</md-table-cell>
        <md-table-cell>{{ client.ville}}</md-table-cell>
        <md-table-cell>{{client.remiseCommercial}}</md-table-cell>
      </md-table-row>
    </md-table>


  </div>
</template>

<script>

  import axios from 'axios';

  export default {
    name: 'FormClient',
    data: () => ({
      showDialog: false,
      clients: [
        {
          nom: '',
          adresse: '',
          codePostal: '',
          ville: '',
          remiseCommercial: ''          
        }        
      ]      
    }),

    created() {
      axios.get(`http://binet-expertise.fr/facturation/server/selectClients.php`)
      .then(response => {
        this.clients = response.data
      })
      .catch(e => {
        console.log(e)
      })
    }    
  }
</script>

<style lang="scss" scoped>
  .md-dialog /deep/.md-dialog-container {
    max-width: 768px;
  }

  .md-raised {
    position: fixed;
    right: 0;
    bottom: 75px;
    margin-left: 16px;
    margin-bottom: 16px;
    height: 50px;
    margin-right: 32px;
  }

  form {
    padding-left: 8px;
    padding-right: 8px;
  }
</style>
